/**
 * Centralized Tracking Classes - SSR Optimized
 * No context needed, works perfectly with Server Components
 * Single source of truth for all event tracking identifiers
 */

import { BUDGET_PAGE_PRICE_RANGES } from "@/app/utilities/constants";
import LoadMoreButton from "@/component/LoadMoreButton";

// Home Page Tracking
export const HOME_TRACKING = {
  POPULAR_CTA: 'home-popular-cta',
  LATEST_CTA: 'home-latest-cta',
  ELECTRIC_CTA: 'home-electric-cta',
  TRENDING_CTA: 'home-trending-cta',
  COMPARISON_CTA: 'home-comparision-cta',
  VIEW_ALL_CTA: 'home-view-all-cta',
  BODY_TAB_CTA: 'home-body-tab-cta',
} as const;

// Popular Cars Page Tracking
export const POPULAR_CARS_TRACKING = {
  LISTING_CTA: 'popular-listing-cta',
  BRAND_CTA: 'popular-car-brand-cta',
  PRICE_RANGE_CTA: 'popular-price-range-cta',
  NEWS_CLICK: 'popular-news-click',
  NEWS_VIEW_ALL: 'popular-news-view-all-click',
  COMPARE_CTA: 'popular-compare-cta',
  COMPARE_VIEW_ALL: 'popular-compare-view-all',
} as const;

// Latest Cars Page Tracking
export const LATEST_CARS_TRACKING = {
  LISTING_CTA: 'latest-listing-cta',
  BRAND_CTA: 'latest-car-brand-cta',
  PRICE_RANGE_CTA: 'latest-price-range-cta',
  NEWS_CLICK: 'latest-news-click',
  NEWS_VIEW_ALL: 'latest-news-view-all-click',
  COMPARE_CTA: 'latest-compare-cta',
  COMPARE_VIEW_ALL: 'latest-compare-view-all',
} as const;

// Electric Cars Page Tracking
export const ELECTRIC_CARS_TRACKING = {
  LISTING_CTA: 'electric-listing-cta',
  POPULAR_CTA: 'electric-popular-car-cta',
  NEWS_CLICK: 'electric-news-click',
  NEWS_VIEW_ALL: 'electric-news-view-all-click',
  COMPARE_CTA: 'electric-compare-cta',
  COMPARE_VIEW_ALL: 'electric-compare-view-all',
} as const;

// Brand Listing Page Tracking
export const BRAND_LISTING_TRACKING = {
  LISTING_CTA: 'brand-listing-cta',
  UPCOMING_CTA: 'brand-upcoming-car-cta',
  COMPARE_CTA: 'brand-compare-cta',
} as const;

// All Brand Listing Page Tracking
export const ALL_BRAND_LISTING_TRACKING = {
  POPULAR_CAR_CTA: 'all-brand-popular-cta',
  EV_CAR_CTA: 'all-brand-ev-cta',
  UPCOMING_CAR_CTA: 'all-brand-upcoming-car-cta',
} as const;

// Compare Page Tracking
export const COMPARE_TRACKING = {
  INPUT: 'compare-input-click',
  CTA: 'compare-now-cta',
  POPULAR_CTA: 'compare-popular-cta',
} as const;

// Compare Result Page Tracking
export const COMPARE_RESULT_TRACKING = {
  EDIT: 'compare-result-edit',
  REMOVE: 'compare-result-remove'
} as const;

// Product Detail Page Tracking
export const PRODUCT_DETAIL_TRACKING = {
  GORP: 'product-detail-gorp',
  VARIANTS_SPECIAL_OFFERS: 'product-detail-variant-special-offer',
  VARIANTS_COMPARE: 'product-detail-variant-compare',
  ELECTRIC_CLICK: 'product-detail-electric-click',
  CALCULATE_EMI_CTA: 'product-detail-cta-calculate-emi',
  LEAD_POPUP_SUMBIT: 'product-detail-lead-popup-submit',
  PDP_CONTACT_SUPPORT_CLICK: 'pdp-contact-support-click',
} as const;

export const PRODUCT_DETAIL_PRICE_LOCATION_TRACKING = {
  BOOK_TEST_DRIVE_CTA: 'price-location-cta-book-test-drive',
  PRICE_IN_CITY_CTA: 'price-location-cta-price-in-city',
  COMPETITORS_Check_CTA: 'price-location-cta-competitors-check',
  COMPETITORS_LOCATION: 'competitors-card-location-click',
  
} as const;

export const CAR_BY_BUDGET_TRACKING = {
  VIEW_MONTH_OFFERS_BUTTON: 'budget-page-view-month-offers',
  BUDGET_PAGE_BRANDS: 'budget-page-brand',
  BUDGET_PAGE_BUDGETS_RANGES: 'budget-page-budget-range',
  BUDGET_PAGE_NEWS: 'budget-page-news-click',
  BUGET_LEAD_FORM_SUBMIT: 'budget-page-lead-form-submit',
} as const;

export const NEW_CAR_PAGE_TRACKING = {
  NEW_CAR_PAGE_BUDGET_TAB: 'new-car-page-budget-tab',
  NEW_CAR_TABS: 'new-car-page-findPerfectCar-tabs',
  NEW_CAR_COMPARE_CTA: 'new-car-page-compare-cta',
  NEW_CAR_UPCOMING_CAR_CTA: 'new-car-page-upcoming-car-cta',
  NEW_CAR_PAGE_SEARCH: 'new-car-page-hero-search',
  NEW_CAR_LEAD_FORM_SUBMIT: 'new-car-page-lead-form-submit',
  NEW_CAR_LEAD_BODY_TYPE_FORM_SUBMIT: 'new-car-body-type-form-submit',
  NEW_CAR_UPCOMING_CAR_LEAD_FORM_SUBMIT: 'new-car-upcoming-car-lead-form-submit',

} as const;

// Cars by Fuel Type Tracking
export const FUEL_TYPE_PAGE_TRACKING = {
  VIEW_MONTH_OFFERS_BUTTON: 'fuel-type-page-view-month-offers',
  FUEL_TYPE_PAGE_BRANDS: 'fuel-type-page-brands', 
  FUEL_TYPE_PAGE_FUEL_TYPES: 'fuel-type-page-fuel-types',
  FUEL_TYPE_PAGE_NEWS: 'fuel-type-page-news-click',
  FUEL_TYPE_LEAD_FORM_SUBMIT: 'fuel-type-page-lead-form-submit',
} as const;

export const PRODUCT_DETAIL_PRICE_SPECIFICATION_TRACKING = {
    SPECIFICATION_CTAGORP: 'specification-cta-gorp',
    SPECIFICATION_CALCULATE_EMI_CTA: 'specification-calculate-emi-cta',
    VARIANTS_SPECIFICATION_COMPARE: 'specification-variant-compare',
    SPECIFICATION_ALTERNATIVE_CTA: 'specification-alternative-cta',
    SPECIFICATION_COMPARE_CTA: 'specification-compare-cta',
    SPECIFICATION_NEWS_CLICK: 'specification-news-click',

    
} as const;

// SeatingCapacityPage
export const SEATING_CAPACITY_PAGE_TRACKING = {
    VIEW_MONTH_OFFERS_BUTTON: 'seating-capacity-Product-card-cta',
    BRAND_CLICK_FROM_SEATING_CAPACITY_PAGE: 'seating-capacity-page-brand-click',
    SEATING_CAPACITY_CHIP_CLICK: 'seating-capacity-page-chip-click',
    SEATING_CAPACITY_PAGE_NEWS_CLICK: 'seating-capacity-page-news-click'
} as const;

export const PDP_EMICALCULATOR_POPUP_TRACKING = {
  PDP_DOWN_PAYMENT_CLICK: 'modal-down-payment-click',
  PDP_INTEREST_RATE_CLICK: 'modal-interest-rate-click',
  PDP_LOAN_PERIOD_CLICK: 'modal-loan-period-click',
  PDP_VARIANT_SELECTOR_CLICK: 'modal-variant-selector-click',  


} as const;

export const EMICALCULATOR_POPUP_TRACKING = {
  DOWN_PAYMENT_CLICK: 'emi-calculator-down-payment-click',
  INTEREST_RATE_CLICK: 'emi-calculator-interest-rate-click',
  LOAN_PERIOD_CLICK: 'emi-calculator-loan-period-click',
  VARIANT_SELECTOR_CLICK: 'emi-calculator-variant-selector-click',
  EMI_LOCATION_CLICK: 'emi-calculator-location-click',
  EMI_PAGE_NEWS_CLICK: 'emi-page-news-click',
  RECOMMENDED_CAR_CLICK: 'recommended-car-click',


} as const;

// Web Stories Tracking
export const WEB_STORIES_TRACKING = {
  STORY_SEARCH: 'web-story-search',
  STORY_CLICK: 'web-story-click',
  STORY_VIEW: 'web-story-view',
  TRENDING_CLICK: 'web-story-trending-click',
  BROWSE_CARS_BY_CATEGORY_CLICK: 'web-story-browse-by-category-click',
  LOAD_MORE_CLICK: 'web-story-load-more-click',

} as const;


export const MODAL_TRACKING = {
  USER_NAME : 'modal-user-name',
  USER_PHONE : 'modal-user-phone',
  MODAL_TRACKING_LOCATION : 'modal-tracking-location',
  MODAL_LEAD_SUBMIT_CTA : 'modal-lead-submit-cta',
  MODAL_CLOSE : 'modal-close-tracking',
} as const

// Category Listing Page Tracking
export const CATEGORY_LISTING_TRACKING = {
  LISTING_CTA: 'category-listing-cta',
  PRICE_LISTING_CTA: 'category-price-listing-cta',
  COMPARE_CTA: 'category-compare-cta',
  COMPARE_VIEW_ALL: 'category-compare-view-all',
} as const;

// Reusable component tracking
export const COMPONENT_TRACKING = {
  BUTTON_CTA: 'btn-cta',
  CARD_CLICK: 'card-click',
  LINK_CLICK: 'link-click',
  MODAL_OPEN: 'modal-open',
  TAB_SELECT: 'tab-select',
  NAVIGATION_CLICK: 'primary-navigation-click',
  SEARCH_INIT: 'search-init',
  SEARCH_COMPLETE: 'search-complete',
  CONTACT_SUPPORT_CLICK: 'contact-support-tracking-click',
} as const;

// Video Player Tracking
export const VIDEO_PLAYER_TRACKING = {
  // Short Videos
  SHORT_VIDEO_SECTION: 'track-short-video-section',
  SHORT_VIDEO_CARD: 'track-short-video-card',
  SHORT_VIDEO_THUMBNAIL: 'track-short-video-thumbnail',
  SHORT_VIDEO_NEXT: 'track-short-video-next',
  SHORT_VIDEO_PREV: 'track-short-video-prev',
  SHORT_VIDEO_CAROUSEL: 'track-short-video-carousel',

  // Long Videos
  LONG_VIDEO_SECTION: 'track-long-video-section',
  LONG_VIDEO_CARD: 'track-long-video-card',
  LONG_VIDEO_THUMBNAIL: 'track-long-video-thumbnail',
  LONG_VIDEO_NEXT: 'track-long-video-next',
  LONG_VIDEO_PREV: 'track-long-video-prev',
  LONG_VIDEO_CAROUSEL: 'track-long-video-carousel',
} as const;

// Brand Budget Page Tracking
export const BRAND_BUDGET_PAGE_TRACKING = {
  // Car Card
  CAR_CARD_CLICK: 'car_card_click',

  // CTA
  VIEW_OFFERS: 'View_Offers',

  // Load More
  LOAD_MORE_CLICK: 'load_more_click',

  // Filters
  FILTER_APPLIED: 'filter_applied',
  FILTER_REMOVED: 'filter_removed',

  // Sort
  SORT_APPLIED: 'sort_applied',

  // Similar Brands
  SIMILAR_BRAND_IMPRESSION: 'similar_brand_impression',
  SIMILAR_BRAND_CLICK: 'similar_brand_click',

  // Brand Budget Navigation
  BUDGET_SLAB_IMPRESSION: 'budget_slab_impression',
  BUDGET_SLAB_CLICK: 'budget_slab_click',

  // All Brands
  ALL_BRANDS_IMPRESSION: 'all_brands_impression',
  BRAND_LOGO_CLICK: 'brand_logo_click',
  ALL_BRANDS_CLICK: 'all_brands',

  // Compare
  COMPARE_CARD_CLICK: 'compare_card_click',
  COMPARE_CTA_CLICK: 'compare_cta_click',

  // Find Your Perfect Car
  BUDGET_CHIP_CLICK: 'budget_chip_click',
  BODY_TYPE_CLICK: 'body_type_click',
  FUEL_TYPE_CLICK: 'fuel_type_click',
  TRANSMISSION_TYPE_CLICK: 'transmission_type_click',
  SEATING_CAPACITY_CLICK: 'seating_capacity_click',

  // Upcoming Cars
  UPCOMING_CAR_CLICK: 'upcoming_car_click',
  NOTIFYME_CLICK: 'notifyme_click',
  VIEW_ALL_UPCOMING_CLICK: 'view_all_upcoming_click',

  // News
  NEWS_CARD_CLICK: 'news_card_click',
  VIEW_ALL_NEWS_CLICK: 'view_all_news_click',

  // FAQ
  FAQ_EXPAND: 'faq_expand',
  FAQ_COLLAPSE: 'faq_collapse',

  // Internal Linking
  SIMILAR_BRAND_NAVIGATION_CLICK: 'similar_brand_navigation_click',
  BUDGET_NAVIGATION_CLICK: 'budget_navigation_click',

  // Lead Journey
  LEAD_FORM_OPEN: 'lead_form_open',
  LEAD_SUBMITTED: 'lead_submitted',

  // SEO / Internal Linking
  BRAND_BUDGET_PAGE_NAVIGATION: 'brand_budget_page_navigation',
  BRAND_BUDGET_INTERNAL_NAVIGATION: 'brand_budget_internal_navigation',
} as const;

// Promoted Model Widget Tracking
export const PROMOTED_MODEL_TRACKING = {
  IMPRESSION: 'promoted-model-impression',
  CARD_CLICK: 'promoted-model-card-click',
  GET_OFFERS_CTA: 'promoted-model-get-offers-cta',
  LEAD_SUBMIT: 'promoted-model-lead-submit',
  LEAD_SOURCE: 'promoted_model_widget',
} as const;

// Convenience export
export const TRACKING = {
  HOME: HOME_TRACKING,
  POPULAR_CARS: POPULAR_CARS_TRACKING,
  LATEST_CARS: LATEST_CARS_TRACKING,
  ELECTRIC_CARS: ELECTRIC_CARS_TRACKING,
  BRAND_LISTING: BRAND_LISTING_TRACKING,
  ALL_BRAND_LISTING: ALL_BRAND_LISTING_TRACKING,
  COMPARE: COMPARE_TRACKING,
  COMPARE_RESULT: COMPARE_RESULT_TRACKING,
  PRODUCT_DETAIL: PRODUCT_DETAIL_TRACKING,
  CATEGORY_LISTING: CATEGORY_LISTING_TRACKING,
  COMPONENT: COMPONENT_TRACKING,
  PRODUCT_DETAIL_PRICE_LOCATION: PRODUCT_DETAIL_PRICE_LOCATION_TRACKING,
  CAR_BY_BUDGET: CAR_BY_BUDGET_TRACKING,
  VIDEO_PLAYER: VIDEO_PLAYER_TRACKING,
  BRAND_BUDGET_PAGE: BRAND_BUDGET_PAGE_TRACKING,
  PROMOTED_MODEL: PROMOTED_MODEL_TRACKING,
} as const;

export type TrackingClass = 
  | typeof HOME_TRACKING[keyof typeof HOME_TRACKING]
  | typeof POPULAR_CARS_TRACKING[keyof typeof POPULAR_CARS_TRACKING]
  | typeof COMPONENT_TRACKING[keyof typeof COMPONENT_TRACKING];
